



















































import Vue from 'vue'
import _ from 'lodash'
// @ts-ignore
import { AgGridVue } from 'ag-grid-vue'
import { QcqCommonGridItem } from '@/types'
import { LOAD_EMPLOYEE_QCQ_COMPETENCE, EDIT_EMPLOYEE_QCQ_COMPETENCE, LOAD_COMPETENCE } from '@/store/action-types'
import { EmployeeQcqCompetence } from '@/model/employee/EmployeeQcqCompetence'
import { MasterDataActionsEnum } from '@/types/enums'
import { EmployeeCompetencePayload } from '@/types/payload'
import {
  DxColumn,
  DxColumnChooser,
  DxDataGrid,
  DxFilterRow,
  DxGrouping,
  DxGroupPanel, DxScrolling, DxSelection,
  DxSorting, DxStateStoring
} from 'devextreme-vue/data-grid'
import deMessages from "devextreme/localization/messages/de.json"
import frMessages from "devextreme/localization/messages/fr.json"
import itMessages from "devextreme/localization/messages/it.json"
import { locale, loadMessages } from "devextreme/localization"
import { Competence } from '@/model/qcq/Competence'
import QcqCompetenceStars from '@/components/employee-form/QcqCompetenceStars.vue'
import ProgressCircular from '@/components/ProgressCircular.vue'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'

interface ComponentData {
  tableHeight: string
  originalGridData: any[]
  gridData: any[]
  employeeCompetenceList: EmployeeQcqCompetence[]
  competencesList: QcqCommonGridItem[]
  loading: boolean
  dataLoading: boolean
  showErrorSnackbar: boolean
  showSuccessSnackbar: boolean
  errorMessage: string
  successMessage: string
  overlayNoRowsTemplate: string
}

export default Vue.extend({
  name: 'QcqCompetence',

  components: {
    AgGridVue,
    QcqCompetenceStars,
    ProgressCircular,
    DxDataGrid,
    DxColumn,
    DxColumnChooser,
    DxSorting,
    DxFilterRow,
    DxGroupPanel,
    DxGrouping,
    DxScrolling,
    DxSelection,
    DxStateStoring
  },

  props: {
    employeeId: Number,
    isCompetencesQualityEnabled: Boolean,
    stars: Number

  },

  data (): ComponentData {
    return {
      tableHeight: 'height: 300px',
      competencesList: [],
      employeeCompetenceList: [],
      originalGridData: [],
      gridData: [],
      loading: false,
      dataLoading: false,
      showErrorSnackbar: false,
      showSuccessSnackbar: false,
      errorMessage: '',
      successMessage: '',
      overlayNoRowsTemplate: "<span>"+this.$t('errors.noRowsToShow')+"</span>"
    }
  },

  computed: {
    selectedLanguageCode (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },
  },

  watch: {
    employeeId (newVal: Number): void {
      if (newVal) {
        this.fetchEmployeeCompetenceList()
      }
    },
  },

  methods: {
    onCancelClick (): void {
      this.gridData = _.cloneDeep(this.originalGridData)
    },

    async onSaveClick (): Promise<void> {
      let addedItems: any[] = []
      let deletedItems: any[] = []
      let updatedItems: any[] = []
      this.gridData.forEach((item: any) => {
        if(item.originalValue !== item.value) {
          if(item.originalValue) {
            deletedItems.push(item)
          } else {
            addedItems.push(item)
          }
        }

        if(item.originalValue && item.originalQuality !== item.quality) {
          updatedItems.push(item)
        }
      })

      let promisesList: Promise<void>[] = []

      addedItems.forEach((item: any) => {
        let payload: EmployeeCompetencePayload = {
          competenceId: item.id,
          action: MasterDataActionsEnum.Create,
          employeeId: this.employeeId,
          competenceOldId: null,
          quality: item.quality
        }
        promisesList.push(this.saveCompetence(payload))
      })

      updatedItems.forEach((item: any) => {
        let payload: EmployeeCompetencePayload = {
          competenceId: item.id,
          action: MasterDataActionsEnum.Update,
          employeeId: this.employeeId,
          competenceOldId: item.id,
          quality: item.quality
        }
        promisesList.push(this.saveCompetence(payload))
      })

      deletedItems.forEach((item: any) => {
        let payload: EmployeeCompetencePayload = {
          competenceId: item.id,
          action: MasterDataActionsEnum.Delete,
          employeeId: this.employeeId,
          competenceOldId: item.id,
          quality: item.quality
        }
        promisesList.push(this.saveCompetence(payload))
      })

      try {
        this.loading = true
        await Promise.all(promisesList)
        this.successMessage = this.$t('success.dataHaveBeenSaved').toString()
        this.showSuccessSnackbar = true
        await this.fetchEmployeeCompetenceList()
      } catch {
        this.errorMessage = this.$t('success.dataCouldNotBeSaved').toString()
        this.showErrorSnackbar = true
      } finally {
        this.loading = false
      }

    },

    async saveCompetence (payload: EmployeeCompetencePayload): Promise<void> {
        await this.$store.dispatch(EDIT_EMPLOYEE_QCQ_COMPETENCE, payload)
    },

    async fetchEmployeeCompetenceList (): Promise<void> {
      const payload: number = this.employeeId
      const data: EmployeeQcqCompetence[] = await this.$store.dispatch(LOAD_EMPLOYEE_QCQ_COMPETENCE, payload)

      this.employeeCompetenceList = data

      this.originalGridData = this.competencesList.map((item: QcqCommonGridItem) => {
        const foundEmployeeCompetence: EmployeeQcqCompetence | undefined = this.employeeCompetenceList.find((i: EmployeeQcqCompetence) => i.competenceId === item.id)
        return {
          id: item.id,
          code: item.code,
          description: item.description,
          originalValue: !!foundEmployeeCompetence,
          value: !!foundEmployeeCompetence,
          originalQuality: foundEmployeeCompetence ? foundEmployeeCompetence.quality : 0,
          quality: foundEmployeeCompetence ? foundEmployeeCompetence.quality : 0
        }
      })

      this.gridData = _.cloneDeep(this.originalGridData)
    },

    async fetchCompetenceList (): Promise<void> {
      try {
        this.dataLoading = true
        const response: Competence[] = await this.$store.dispatch(LOAD_COMPETENCE, 1)
        this.dataLoading = false
        response.forEach((item: Competence) => {
          this.competencesList.push(item.commonGridData)
        })
      } catch {
        this.dataLoading = false
      }
    },

    onResize (): void {
      if(this.$vuetify.breakpoint.mdAndUp) {
        const vh = window.innerHeight
        if(vh > 500) {
          this.tableHeight = `height: calc(${vh}px - 332px)`
        } else {
          this.tableHeight = 'height: 300px'
        }
      } else {
        this.tableHeight = 'height: 300px'
      }
    }
  },

  created (): void {
    loadMessages(deMessages)
    loadMessages(frMessages)
    loadMessages(itMessages)
    locale(this.selectedLanguageCode)
  },

  async mounted (): Promise<void> {
    await this.fetchCompetenceList()
    await this.fetchEmployeeCompetenceList()
  }

})
